export function isDecorHaveSurface(surfacesOfDecor, surfaceKey) {
    if (!surfacesOfDecor) {
        return false;
    }
    for (let item of surfacesOfDecor) {
        if (item.code === surfaceKey) {
            return true;
        }
    }
    return false;
}
